import {
  Delete,
  Logout,
  PdfIcon,
  PortSvg,
  DocxIcon,
  HomeIcon,
  XlsxIcon,
  ArrowDown,
  CloudIcon,
  PointHere,
  Progress1,
  Progress2,
  Progress3,
  Progress4,
  Progress5,
  Progress6,
  Satellite,
  ExcelIcon,
  FilterIcon,
  LintasIcon,
  SearchIcon,
  StreetView,
  VesselIcon,
  NAReportIcon,
  OKReportIcon,
  Progress3Red,
  ProgressDone,
  ProgressGrey,
  EquipmentIcon,
  FloatingCrane,
  Progress2Grey,
  ProgressError,
  SavedAsSubmit,
  FolderDocument,
  FormFilledIcon,
  FullScreenExit,
  FullScreenEnter,
  UnfinalizedWApprovalIcon,
  UnfinalizedWOApprovalIcon,
} from './svg.component'

import {
  ProgGrey,
  CompGrey,
  FinalGrey,
  DraftGrey,
  AppRejGrey,
  WaitAppGrey,
  //
  ProgGreen,
  CompGreen,
  FinalGreen,
  DraftGreen,
  AppRejGreen,
  WaitAppGreen,
  //
  ProgRed,
  CompRed,
  FinalRed,
  DraftRed,
  AppRejRed,
  WaitAppRed
} from './svg.service-request.component'

export {
  Logout,
  PortSvg,
  PdfIcon,
  DocxIcon,
  XlsxIcon,
  HomeIcon,
  ArrowDown,
  PointHere,
  Satellite,
  Progress1,
  Progress2,
  Progress2Grey,
  Progress3,
  Progress3Red,
  Progress4,
  Progress5,
  Progress6,
  CloudIcon,
  VesselIcon,
  SearchIcon,
  StreetView,
  LintasIcon,
  ProgressGrey,
  ProgressDone,
  ProgressError,
  EquipmentIcon,
  FloatingCrane,
  FullScreenExit,
  FullScreenEnter,
  Delete,
  ExcelIcon,
  FilterIcon,
  FormFilledIcon,
  NAReportIcon,
  OKReportIcon,
  //-----SERVICE-REQUEST-------//
  //grey
  ProgGrey,
  CompGrey,
  FinalGrey,
  DraftGrey,
  AppRejGrey,
  WaitAppGrey,
  //green
  ProgGreen,
  CompGreen,
  FinalGreen,
  DraftGreen,
  AppRejGreen,
  WaitAppGreen,
  //red
  ProgRed,
  CompRed,
  FinalRed,
  DraftRed,
  AppRejRed,
  WaitAppRed,
  SavedAsSubmit,
  UnfinalizedWApprovalIcon,
  UnfinalizedWOApprovalIcon,
  FolderDocument,
}
